import Bmob from "hydrogen-js-sdk";
export class BmobMessage {
    content;
    loading = false;
    page = 0;
    size = 1;
    constructor(content) {
        this.content = content;
    }
    create = () => {
        this.loading = true;
        return new Promise((resolve, reject) => {
            const query = Bmob.Query("message");
            query.set("name", this.content.name);
            query.set("content", this.content.content);
            query.add("files", this.content.files || []);
            query
                .save()
                .then(() => {
                resolve();
            })
                .catch(() => {
                reject();
            });
            this.loading = false;
        });
    };
    findAll() {
        return new Promise((resolve, reject) => {
            const query = Bmob.Query("message");
            query.order("-createdAt");
            query.limit(this.size);
            query.skip(this.page * this.size);
            query
                .find()
                .then(res => {
                const messages = res;
                messages.forEach(item => {
                    item.state = false;
                });
                resolve(messages);
            })
                .catch(() => {
                reject();
            });
        });
    }
}
